import { SvgIcon } from '@material-ui/core'
import React from 'react'

const SplitIcon = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <g className="outline">
        <path
          fillRule="evenodd"
          d="M2.5 8.22302C2.5 7.94688 2.72386 7.72302 3 7.72302H10.9989C11.275 7.72302 11.4989 7.94688 11.4989 8.22302C11.4989 8.49916 11.275 8.72302 10.9989 8.72302H3C2.72386 8.72302 2.5 8.49916 2.5 8.22302Z"
        />
        <path
          fillRule="evenodd"
          d="M2.50098 4.43646C2.50098 4.16032 2.72483 3.93646 3.00098 3.93646H10.9999C11.276 3.93646 11.4999 4.16032 11.4999 4.43646C11.4999 4.7126 11.276 4.93646 10.9999 4.93646H3.00098C2.72483 4.93646 2.50098 4.7126 2.50098 4.43646Z"
        />
        <path
          fillRule="evenodd"
          d="M2.5 12.0103C2.5 11.7341 2.72386 11.5103 3 11.5103H10.9989C11.275 11.5103 11.4989 11.7341 11.4989 12.0103C11.4989 12.2864 11.275 12.5103 10.9989 12.5103H3C2.72386 12.5103 2.5 12.2864 2.5 12.0103Z"
        />
        <path
          fillRule="evenodd"
          d="M2.5 15.7972C2.5 15.5211 2.72386 15.2972 3 15.2972H10.9989C11.275 15.2972 11.4989 15.5211 11.4989 15.7972C11.4989 16.0734 11.275 16.2972 10.9989 16.2972H3C2.72386 16.2972 2.5 16.0734 2.5 15.7972Z"
        />
        <path
          fillRule="evenodd"
          d="M2.5 19.5842C2.5 19.308 2.72386 19.0842 3 19.0842H10.9989C11.275 19.0842 11.4989 19.308 11.4989 19.5842C11.4989 19.8603 11.275 20.0842 10.9989 20.0842H3C2.72386 20.0842 2.5 19.8603 2.5 19.5842Z"
        />
        <path
          fillRule="evenodd"
          d="M20.0455 5H14.9545C14.7035 5 14.5 5.20351 14.5 5.45455V18.5455C14.5 18.7965 14.7035 19 14.9545 19H20.0455C20.2965 19 20.5 18.7965 20.5 18.5455V5.45455C20.5 5.20351 20.2965 5 20.0455 5ZM14.9545 4C14.1512 4 13.5 4.65122 13.5 5.45455V18.5455C13.5 19.3488 14.1512 20 14.9545 20H20.0455C20.8488 20 21.5 19.3488 21.5 18.5455V5.45455C21.5 4.65122 20.8488 4 20.0455 4H14.9545Z"
        />
      </g>
      <g className="filled">
        <path
          fillRule="evenodd"
          d="M2.5 8.22302C2.5 7.94688 2.72386 7.72302 3 7.72302H10.9989C11.275 7.72302 11.4989 7.94688 11.4989 8.22302C11.4989 8.49916 11.275 8.72302 10.9989 8.72302H3C2.72386 8.72302 2.5 8.49916 2.5 8.22302Z"
        />
        <path
          fillRule="evenodd"
          d="M2.50098 4.43646C2.50098 4.16032 2.72483 3.93646 3.00098 3.93646H10.9999C11.276 3.93646 11.4999 4.16032 11.4999 4.43646C11.4999 4.7126 11.276 4.93646 10.9999 4.93646H3.00098C2.72483 4.93646 2.50098 4.7126 2.50098 4.43646Z"
        />
        <path
          fillRule="evenodd"
          d="M2.5 12.0103C2.5 11.7341 2.72386 11.5103 3 11.5103H10.9989C11.275 11.5103 11.4989 11.7341 11.4989 12.0103C11.4989 12.2864 11.275 12.5103 10.9989 12.5103H3C2.72386 12.5103 2.5 12.2864 2.5 12.0103Z"
        />
        <path
          fillRule="evenodd"
          d="M2.5 15.7972C2.5 15.5211 2.72386 15.2972 3 15.2972H10.9989C11.275 15.2972 11.4989 15.5211 11.4989 15.7972C11.4989 16.0734 11.275 16.2972 10.9989 16.2972H3C2.72386 16.2972 2.5 16.0734 2.5 15.7972Z"
        />
        <path
          fillRule="evenodd"
          d="M2.5 19.5842C2.5 19.308 2.72386 19.0842 3 19.0842H10.9989C11.275 19.0842 11.4989 19.308 11.4989 19.5842C11.4989 19.8603 11.275 20.0842 10.9989 20.0842H3C2.72386 20.0842 2.5 19.8603 2.5 19.5842Z"
        />
        <path d="M13.5 5.45455C13.5 4.65122 14.1512 4 14.9545 4H20.0455C20.8488 4 21.5 4.65122 21.5 5.45455V18.5455C21.5 19.3488 20.8488 20 20.0455 20H14.9545C14.1512 20 13.5 19.3488 13.5 18.5455V5.45455Z" />
        <path
          fillRule="evenodd"
          d="M20.0455 5H14.9545C14.7035 5 14.5 5.20351 14.5 5.45455V18.5455C14.5 18.7965 14.7035 19 14.9545 19H20.0455C20.2965 19 20.5 18.7965 20.5 18.5455V5.45455C20.5 5.20351 20.2965 5 20.0455 5ZM14.9545 4C14.1512 4 13.5 4.65122 13.5 5.45455V18.5455C13.5 19.3488 14.1512 20 14.9545 20H20.0455C20.8488 20 21.5 19.3488 21.5 18.5455V5.45455C21.5 4.65122 20.8488 4 20.0455 4H14.9545Z"
        />
      </g>
    </SvgIcon>
  )
}

export default SplitIcon
